import(/* webpackMode: "eager", webpackExports: ["Chat"] */ "/vercel/path0/components/chat.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/tv/trading-view-wrapper.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
